/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Source Transfer Peer Type
 */
export type InstructionQuoteRequestAttributesSourceType = typeof InstructionQuoteRequestAttributesSourceType[keyof typeof InstructionQuoteRequestAttributesSourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InstructionQuoteRequestAttributesSourceType = {
  MERCHANT: 'MERCHANT',
  ACCOUNT: 'ACCOUNT',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  BANK_ACCOUNT_V2: 'BANK_ACCOUNT_V2',
  CASH_PICKUP: 'CASH_PICKUP',
  UNIONPAY: 'UNIONPAY',
  CASH_DROP_OFF: 'CASH_DROP_OFF',
  DIGITAL_ADDRESS: 'DIGITAL_ADDRESS',
  PAYEE: 'PAYEE',
  CREDIT_CARD: 'CREDIT_CARD',
  ALIPAY: 'ALIPAY',
  PEER_ACCOUNT: 'PEER_ACCOUNT',
} as const;
